import axios from "../api";
export const getGalleryLevels = async () => {
    const res = await axios.get("/gallery/levels");
    return res.data;
};
/** Builds and stores a level plan for a Gallery level within `limits`, with `options`; up to about 20 s. */
export const buildGalleryLevelPlan = async (level, settings) => {
    const res = await axios.post("/gallery/level-plan", {
        level,
        ...settings,
    });
    return res.data;
};
/** Marks one set of the stored level plan done or not done; done also saves its planned grade as the Completed grade. */
export const setGalleryLevelPlanSetDone = async (setId, done) => {
    await axios.put(`/gallery/levels/sets/${setId}/done`, { done });
};
/** One set of the stored level plan with players and prices. */
export const getGalleryLevelPlanSet = async (setId) => {
    const res = await axios.get(`/gallery/levels/sets/${setId}`);
    return res.data;
};
//# sourceMappingURL=galleryLevels.js.map